<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="c07"><a id="page08"></a>Did Ya Hear the One About …?</h1>
<p class="nonindent"><span class="dropcaps">A</span>fter most weddings someone, usually the groom’s friends, plays a prank on the newly married ample. After being married only a month, Raul Hortena realized the joke was on him when he appeared in front of a Barcelona court asking for a divorce. The judge turned down the request because he discovered that Raul-the-Fool had used invisible ink when he signed his marriage certificate. The <em>Guardian</em> reported that Raul was also fined approximately $200 for forging an official document.<img alt="" src="OEBPS/images/Greg_9780740792069_epub_L04_r1.jpg"/></p>
<div class="textbox">
<p class="center"><img alt="" src="OEBPS/images/Greg_9780740792069_epub_L05_r1.jpg"/></p>
<p class="center">BONNIE BLOWS CLINTON</p>
<p class="center"><img alt="" src="OEBPS/images/Greg_9780740792069_epub_L06_r1.jpg"/></p>
</div>
<p class="center"><span class="small">Article regarding Hurricane Bonnie hitting Clinton, North Carolina.<br/>— <em>The Sampson Independent,</em> August 27, 1998.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740792069_epub_c07_r1.vue?7e234c5f